var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / chevron-v"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47206 2.19526C8.34703 2.07024 8.17746 2 8.00065 2C7.82384 2 7.65427 2.07024 7.52925 2.19526L3.52925 6.19526C3.2689 6.45561 3.2689 6.87772 3.52925 7.13807C3.7896 7.39842 4.21171 7.39842 4.47206 7.13807L8.00065 3.60948L11.5292 7.13807C11.7896 7.39842 12.2117 7.39842 12.4721 7.13807C12.7324 6.87772 12.7324 6.45561 12.4721 6.19526L8.47206 2.19526Z",
    fill: "#667185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47206 14.4714C8.34703 14.5964 8.17746 14.6667 8.00065 14.6667C7.82384 14.6667 7.65427 14.5964 7.52925 14.4714L3.52925 10.4714C3.2689 10.2111 3.2689 9.78895 3.52925 9.52859C3.7896 9.26825 4.21171 9.26825 4.47206 9.52859L8.00065 13.0572L11.5292 9.52859C11.7896 9.26825 12.2117 9.26825 12.4721 9.52859C12.7324 9.78895 12.7324 10.2111 12.4721 10.4714L8.47206 14.4714Z",
    fill: "#667185"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.e503528c7b63150a7eebd48b95bae013.svg";
export { ForwardRef as ReactComponent };